import { StaticDocument } from '@inyova/models';

import { createAction, props } from '@ngrx/store';

import { Country } from '@shared/models/Account';
import {
  ChCityResponse,
  GrowDocument,
  LibertyDocument,
  NewDocType,
  PersonalDetails,
  PersonalDetailsCurrentScreen,
  TwoFAScreen
} from '@shared/models/Profile';

export const getPersonalDetails = createAction('[Profile] Get personal details');
export const getPersonalDetailsSuccess = createAction('[Profile] Get personal details success', props<{ personalDetails: PersonalDetails }>());
export const fetchCountries = createAction('[Profile] Get countries');
export const fetchCountriesSuccess = createAction('[Profile] Get countries success', props<{ countries: Country[] }>());
export const send2FAAuthorizationCode = createAction('[Profile] Send 2FA authorization code', props<{ redirect: string; authToken: string }>());
export const updateShow2FADisableModal = createAction('[Profile] Update show 2FA disable modal', props<{ show: boolean }>());
export const updatePersonalDetailsCurrentScreen = createAction(
  '[Profile] Update personal details current screen',
  props<{ screen: PersonalDetailsCurrentScreen }>()
);
export const toggle2FAAuthorization = createAction('[Profile] Toggle 2FA authorization', props<{ code: string }>());
export const update2FACurrentScreen = createAction('[Profile] Update 2FA current screen', props<{ screen: TwoFAScreen }>());
export const update2FALoading = createAction('[Profile] Update 2FA loading', props<{ loading: boolean }>());
export const updatePersonalDetailsLoading = createAction('[Profile] Update personal details loading', props<{ loading: boolean }>());
export const updateCustomerPhoneAndSend2FACode = createAction(
  '[Profile] Update customer phone and send 2FA code',
  props<{ authToken: string; personalDetails: Partial<PersonalDetails> }>()
);
export const updatePersonalDetails = createAction('[Profile] Update personal details', props<{ personalDetails: PersonalDetails }>());
// update profile address
export const updateProfileAddress = createAction('[Profile] Update profile address', props<{ personalDetails: Partial<PersonalDetails> }>());
export const updateProfileAddressSuccess = createAction(
  '[Profile] Update profile address success',
  props<{ personalDetails: Partial<PersonalDetails> }>()
);
export const updateProfileAddressFailed = createAction('[Profile] Update profile address failed');
// update profile email
export const updateProfileEmail = createAction('[Profile] Update profile email', props<{ personalDetails: Partial<PersonalDetails> }>());
export const updateProfileEmailSuccess = createAction(
  '[Profile] Update profile email success',
  props<{ personalDetails: Partial<PersonalDetails> }>()
);
export const updateProfileEmailFailed = createAction('[Profile] Update profile email failed');
// update profile mobile phone
export const updateProfileMobilePhone = createAction(
  '[Profile] Update profile mobile phone',
  props<{ personalDetails: Partial<PersonalDetails>; has3AAccountMinProspect: boolean; twoFAEnabled: boolean }>()
);
export const updateProfileMobilePhoneSuccess = createAction(
  '[Profile] Update profile mobile phone success',
  props<{ personalDetails: Partial<PersonalDetails>; has3AAccountMinProspect: boolean; twoFAEnabled: boolean }>()
);
export const updateProfileMobilePhoneFailed = createAction('[Profile] Update profile mobile phone failed');
// update owner name
export const updateProfileOwnerName = createAction('[Profile] Update profile owner name', props<{ accountId: string; ownerName: string }>());
export const updateProfileOwnerSuccess = createAction(
  '[Profile] Update profile owner name success',
  props<{ accountId: string; ownerName: string }>()
);
export const updateProfileOwnerFailed = createAction('[Profile] Update profile owner name failed', props<{ error }>());
export const toggleProfileI4KList = createAction('[Profile] Toggle profile I4K List', props<{ showI4KNameList: boolean }>());

export const updateCustomerLanguage = createAction('[Profile] Update customer language', props<{ personalDetails: Partial<PersonalDetails> }>());

// validate password
export const validatePassword = createAction('[Profile] Validate password', props<{ password: string }>());
export const validatePasswordSuccess = createAction('[Profile] Validate password success');
export const validatePasswordFailed = createAction('[Profile] Validate password failed');
export const validatePasswordReset = createAction('[Profile] Validate password reset');
// send OTP code
export const sendOtpCode = createAction('[Profile] Send OTP code');
export const sendOtpCodeSuccess = createAction('[Profile] Send OTP code success');
export const sendOtpCodeFailed = createAction('[Profile] Send OTP code failed');
export const sendOtpCodeReset = createAction('[Profile] Send OTP code reset');
// validate phone
export const validateMobilePhone = createAction('[Profile] Validate mobile phone', props<{ code: string }>());
export const validateMobilePhoneSuccess = createAction('[Profile] Validate mobile phone success');
export const validateMobilePhoneFailed = createAction('[Profile] Validate mobile phone failed');

export const validatePassword2FA = createAction(
  '[Profile] Validate password 2FA',
  props<{ password: string; enabled2FA: boolean; authToken: string }>()
);
export const logout = createAction('[Profile] Logout');

export const updateProfilePassword = createAction(
  '[Profile] Update password',
  props<{ currentPassword: string; newPassword: string; newPasswordConfirmation: string }>()
);
export const updateProfilePasswordStatus = createAction('[Profile] Update password success', props<{ status: any }>());

export const fetchCustomerDocs = createAction('[Profile] Get customer docs');
export const fetchCustomerDocsSuccess = createAction('[Profile] Get customer docs success', props<{ documents: NewDocType[] }>());
export const fetchCustomerDocsFail = createAction('[Profile] Get customer docs fail');

export const fetchLibertyDocs = createAction(
  '[Profile] Liberty documents update',
  props<{ perItem: number; page: number; sort: string; filter: string }>()
);
export const fetchLibertyDocsSuccess = createAction(
  '[Profile] Liberty documents update success',
  props<{ docs: LibertyDocument[]; total: number; pageIndex: number; filter: string; sort: string }>()
);
export const fetchLibertyDocsFail = createAction('[Profile] Liberty documents update fail');

export const fetchGrowDocs = createAction('[Profile] Get grow documents');
export const fetchGrowDocsSuccess = createAction('[Profile] Get grow documents success', props<{ documents: GrowDocument[] }>());
export const fetchGrowDocsFail = createAction('[Profile] Get grow documents fail');

export const fetchStaticDocs = createAction('[Profile] Get static documents', (filter: null | 'crowd_investing' | '3a' | '3b' | 'grow' = null) => ({
  filter
}));
export const fetchStaticDocsSuccess = createAction('[Profile] Get static documents success', props<{ documents: StaticDocument[] }>());
export const fetchStaticDocsFail = createAction('[Profile] Get static documents fail');

// get CH cities
export const getChCity = createAction('[Profile] Get CH city', props<{ zipCode: string }>());
export const getChCitySuccess = createAction('[Profile] Get CH city success', props<{ response: ChCityResponse }>());
export const getChCityFailed = createAction('[Profile] Get CH city failed', props<{ error: any }>());
export const resetChCity = createAction('[Profile] Reset CH city');
